import React, { useState, useEffect } from 'react'; 
import Loader from "../../../../components/Loader/Loader";
import { getAgent, toggleAgentStatus } from '../../../Map/store/Avatars/AvatarsThunks';
import { useDispatch, useSelector } from 'react-redux';
import { ACTIVE_AGENTS } from '../../store/mediaControlSlice';

export default function AgentControlPanel({
    name,
    onChevronClick,
    hasChevron = false,
    loading = false,
    disabled = false,
    activeIcon,
    inactiveIcon,
    activeStyle = "icon-active",
    inactiveStyle = "icon-inactive",
}) {
    const [isActive, setIsActive] = useState(false);
    const { agents } = useSelector((state) => state.avatars);
    const { localAvatar } = useSelector(state => state.auth);

  const dispatch = useDispatch();
  useEffect(() => {
        if (agents && agents.length > 0) {
            setIsActive(true);
        } else {
            setIsActive(false);
        }
    }, [agents]);
const handleToggleActive = async () => {
        if (loading || disabled) return;

        try {
            await dispatch(toggleAgentStatus({ 
                params: [{ name: "ANNA" }] 
            })).unwrap(); 
            dispatch(ACTIVE_AGENTS({tenantId: localAvatar.tenant_id}))
            setIsActive(prev => !prev);
            } catch (error) {
            console.error("Erreur lors du changement de statut :", error);
        }
    };

    return (

            <button 
                disabled={disabled}
                className={`control-btn ${isActive ? activeStyle : inactiveStyle}`}
                onClick={handleToggleActive}
            >
                {loading && (
                    <span className="loader-device-bg">
                        <Loader className="loader-device" />
                    </span>
                )}

                <span className="menu-icon">
                    <span className="material-symbols-outlined" alt={name}>
                        {isActive ? activeIcon : inactiveIcon}
                    </span>
                    <span className="label-btn">Agent IA</span>
                </span>

                {hasChevron && (
                    <span 
                        className="material-symbols-outlined arrow" 
                        onClick={(e) => {
                            e.stopPropagation(); 
                            onChevronClick(e.currentTarget);
                        }}
                    >
                        keyboard_arrow_up
                    </span>
                )}
            </button>
       
    );
}